// extracted by mini-css-extract-plugin
module.exports = {"content":"jc","lookName":"kc","shopTheLookContainer":"lc","productContainer":"mc","imageContainer":"nc","mainImage":"oc"};